import * as React from "react";
import type { SVGProps } from "react";
const SvgTrendDown02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.7 7.37V17.7m0 0H7.517m10.183 0L6.3 6.3"
    />
  </svg>
);
export default SvgTrendDown02;
